module.exports = __webpack_public_path__ + "static/img/about-join.c1ec0a1a.png";